import axios from 'axios';

import notification from '../utils/notification';

import { SET_DEPARTMENTS } from './types';

export const setDepartments =
	({ departments }) =>
	async (dispatch) => {
		dispatch({ type: SET_DEPARTMENTS, payload: departments });
	};

export const getDepartments =
	({ isEnterpriseRequested = false }) =>
	async (dispatch) => {
		try {
			const res = await axios.get(
				`/api/departments/get-departments?isEnterpriseRequested=${isEnterpriseRequested}`,
				{ _suppressErrorToast: true }
			);

			const { data } = res;

			if (data.departments) {
				dispatch({ type: SET_DEPARTMENTS, payload: data.departments });
			}
		} catch {
			dispatch(
				notification(
					'Error',
					'Failed to load departments. Please try again.',
					true
				)
			);
		}
	};

export const createNewDepartment = (department) => async (dispatch) => {
	try {
		const res = await axios.post(
			'/api/departments/create-new-department',
			{ department },
			{ _suppressErrorToast: true }
		);

		const { data } = res;

		if (data.error) {
			const message =
				data.message ||
				'There was an error creating your department. Please refresh the page and try again.';
			dispatch(notification('Error', message, true));
			return { error: true };
		}

		if (data.departments) {
			dispatch({ type: SET_DEPARTMENTS, payload: data.departments });
			dispatch(
				notification(
					'Success',
					`Created new department: ${department.name}`,
					false
				)
			);
			return { error: false };
		}

		return { error: true };
	} catch {
		dispatch(
			notification(
				'Error',
				'There was an error creating your department. Please try again.',
				true
			)
		);
		return { error: true };
	}
};

export const editDepartment = (department) => async (dispatch) => {
	try {
		const res = await axios.post(
			'/api/departments/edit-department',
			{ department },
			{ _suppressErrorToast: true }
		);

		const { data } = res;

		if (data.error) {
			const message =
				data.message ||
				'There was an error editing your department. Please refresh the page and try again.';
			dispatch(notification('Error', message, true));
			return { error: true };
		}

		if (data.departments) {
			dispatch({ type: SET_DEPARTMENTS, payload: data.departments });
			dispatch(
				notification(
					'Success',
					`Updated department: ${department.name}`,
					false
				)
			);
			return { error: false };
		}

		return { error: true };
	} catch {
		dispatch(
			notification(
				'Error',
				'There was an error editing your department. Please try again.',
				true
			)
		);
		return { error: true };
	}
};

export const deleteDepartment = (department) => async (dispatch) => {
	try {
		const res = await axios.post(
			'/api/departments/delete-department',
			{ department },
			{ _suppressErrorToast: true }
		);

		const { data } = res;

		if (data.error) {
			const message =
				data.message ||
				'There was an error deleting your department. Please refresh the page and try again.';
			dispatch(notification('Error', message, true));
			return { error: true };
		}

		if (data.departments) {
			dispatch({ type: SET_DEPARTMENTS, payload: data.departments });
			dispatch(notification('Success', `Deleted department.`, false));
			return { error: false };
		}

		return { error: true };
	} catch {
		dispatch(
			notification(
				'Error',
				'There was an error deleting your department. Please try again.',
				true
			)
		);
		return { error: true };
	}
};
